"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShopperBaskets = void 0;
var _ocapiShopperBaskets = require("./ocapi-shopper-baskets");
var sdk = _interopRequireWildcard(require("commerce-sdk-isomorphic"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// This class is an extension to OcapiShopperBaskets class to include basket functions implemented in SCAPI.
// Current implementation has ShopperBaskets interactiing with OCAPI which misses new functions implemented in newer SCAPI releases.
class ShopperBaskets extends _ocapiShopperBaskets.OcapiShopperBaskets {
  // @ts-ignore

  constructor(config) {
    super(config);
    this.shopperBasketsClient = new sdk.ShopperBaskets(config);
  }
  mergeBasket(args) {
    return this.shopperBasketsClient.mergeBasket(args);
  }
  transferBasket(args) {
    return this.shopperBasketsClient.transferBasket(args);
  }
}
exports.ShopperBaskets = ShopperBaskets;